// ------------------------------------
// Menu Mobile
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $btnMenu = $('.menu-mobile-btn');
  const $btnCloseMenu = $('.header-menu-close');
  const $menuMobile = $('.header-menu');
  const $body = $('body');
  let active = false;

  // Eventos
  $btnMenu.on('click', showMenuMobile);
  $btnCloseMenu.on('click', hideMenuMobile);

  // Fecha o menu ao clicar em algum link
  $menuMobile.find('a').on('click', function () {
    if (isMedia('md') || isMedia('sm') || isMedia('xs')) {
      hideMenuMobile();
    }
  });

  // Exibe ou oculta o menu mobile
  function toggleMenuMobile() {
    if ($menuMobile.hasClass('active')) {
      hideMenuMobile();
    } else {
      showMenuMobile();
    }
  }

  // Exibe o menu mobile
  function showMenuMobile() {
    active = true;
    $body.addClass('scroll-disabled');
    $btnMenu.addClass('active');
    $menuMobile.addClass('active');
  }

  // Oculta o menu mobile
  function hideMenuMobile() {
    active = false;
    $body.removeClass('scroll-disabled');
    $btnMenu.removeClass('active');
    $menuMobile.removeClass('active');
  }
})();
